import { Box } from '@mui/material';

import Accordion from '../../accordion/accordion';
import Typography from '../../typography/typography';

export interface IItemsSummary {
	totalQuantity: number | string;
	total: number | string;
	currencySymbol: string;
}
interface IItemsSummaryProps {
	data: IItemsSummary;
}

const ItemsSummary: React.FC<IItemsSummaryProps> = ({ data }) => {
	return (
		<Accordion
			title={
				<Typography type='s3' weight='medium' color='theme.secondary.1000'>
					Items
				</Typography>
			}
			accordionProps={{
				defaultExpanded: true,
				sx: {
					borderBottomWidth: 1,
					'& .MuiAccordionSummary-root': { borderBottomWidth: 1 }
				}
			}}>
			<Box className='calculationSummary--SummaryContainer'>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Total Quantity
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.totalQuantity}
					</Typography>
				</Box>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Total
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.total}
					</Typography>
				</Box>
			</Box>
		</Accordion>
	);
};

export default ItemsSummary;
